import { render } from "./TrustedBy.vue?vue&type=template&id=b9042752&scoped=true"
const script = {}

import "./TrustedBy.vue?vue&type=style&index=0&id=b9042752&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9042752"]])

export default __exports__